module.exports = __webpack_public_path__ + "static/media/uploadfile.aef66ce1.svg";